export const leadOverviewConstants = {
  ADD_LEAD_SUCCESS: 'ADD_LEAD_SUCCESS',
  ADD_LEAD_FAIL: 'ADD_LEAD_FAIL',
  RESET_LEADOVERVIEW: 'RESET_LEADOVERVIEW',
  UPDATE_LEADCOMMENT: 'UPDATE_LEADCOMMENT',
}
